import { useLocalization } from "../../hooks/useLocalization";
import { defaultProfileIconUrl } from "../../utils/leaderboard/profile-icons";

interface ProfileIconProps {
  size?: number;
  className?: string;
}

export const ProfileIcon = ({ size = 40, className = "" }: ProfileIconProps) => {
  const { strings } = useLocalization();

  return (
    <img
      className={`h-10 w-10 shrink-0 rounded-[10px] bg-[#2a2a36] object-cover ${className}`}
      src={defaultProfileIconUrl()}
      alt={strings.LEADERBOARD.PROFILE_ICON_ALT}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      referrerPolicy="no-referrer"
    />
  );
};
